import { SelectHTMLAttributes, forwardRef } from 'react';

import { twMerge } from 'tailwind-merge';

const selectSizes = {
  sm: 'p-2',
  md: 'p-2.5',
  lg: 'px-4 py-3',
};

type SelectTypes = {
  readonly selectSize?: keyof typeof selectSizes;
};

type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & SelectTypes;
type Ref = HTMLSelectElement;

const Select = forwardRef<Ref, SelectProps>(function Select(props, ref) {
  const { children, selectSize = 'md', className, ...rest } = props;
  const classes = twMerge(
    'block w-full appearance-none text-sm outline-0',
    'rounded-lg border border-neutral-300',
    'bg-neutral-50 text-neutral-900',
    'focus:border-blue-300 focus:ring-blue-300',
    'disabled:border-neutral-300 disabled:bg-neutral-100 disabled:text-neutral-500',
    'dark:border-neutral-700 dark:bg-neutral-700 dark:text-white dark:placeholder:text-neutral-400 dark:focus:border-light-blue-500 dark:focus:ring-light-blue-500',
    selectSizes[selectSize],
    className,
  );

  return (
    <select {...rest} ref={ref} className={classes}>
      {children}
    </select>
  );
});

export { Select };
